import React from 'react';
import {ReactComponent as LogoIcon} from '../../../../assets/header/logo.svg';
import {ReactComponent as NotFoundIcon} from '../../../../assets/i/not-found.svg';
import '../not-found.css'
import '../../offline/ofline.css'
import { useRouteError } from 'react-router-dom';
import {AxiosError} from "axios";

export const NotFoundContainer = () => {
    // const error = useRouteError()
    return (
        <div className='offline-container'>
            <div className='not-found-left'>
                <div className='not-found-left-svg'>
                    <NotFoundIcon/>
                </div>
            </div>
            <div className='offline-right'>
                <div className='offline-right-box'>
                    <div className="not-found-right-error-box">
                        {/*{(error as AxiosError).status}*/}
                        404
                    </div>
                    <div className="offline-right-text-box">
                        <span>Страница не найдена</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

